import { NgModule } from '@angular/core';
import { StoryBlokLinkModule } from '../../../../shared/storyblok/link/link.module';
import { BaseModule } from '../../../../shared/base.module';
import { MeLandingPageExpertComponent } from './landing-page-expert.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ModalModule } from 'ngx-bootstrap/modal';


@NgModule({
    imports: [
        BaseModule,
        StoryBlokLinkModule,
        CarouselModule,
        ModalModule.forRoot(),
    ],
    declarations: [
        MeLandingPageExpertComponent
    ],
    exports: [
        MeLandingPageExpertComponent
    ]
})

export class MeLandingPageExpertModule { }
